import { lazy } from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import InmateLayout from "@/layouts/InmateLayout";

const InmateDashboard = lazy(() => import("@/pages/inmate/InmateDashboard"));
const MoodTrackerPage = lazy(() => import("@/pages/inmate/MoodTrackerPage"));
const JournalPage = lazy(() => import("@/pages/inmate/JournalPage"));
const ChatPage = lazy(() => import("@/pages/inmate/ChatPage"));
const CrisisPage = lazy(() => import("@/pages/inmate/CrisisPage"));
const SkillsHub = lazy(() => import("@/pages/inmate/SkillsHub"));
const SkillDetail = lazy(() => import("@/pages/inmate/SkillDetail"));
const ChallengesPage = lazy(() => import("@/pages/inmate/ChallengesPage"));
const HabitsPage = lazy(() => import("@/pages/inmate/HabitsPage"));
const GratitudePage = lazy(() => import("@/pages/inmate/GratitudePage"));
const GoalsPage = lazy(() => import("@/pages/inmate/GoalsPage"));
const InsightsPage = lazy(() => import("@/pages/inmate/InsightsPage"));
const AccountabilityPage = lazy(() => import("@/pages/inmate/AccountabilityPage"));
const RestorationPlanPage = lazy(() => import("@/pages/inmate/RestorationPlanPage"));
const MyReentryPlanPage = lazy(() => import("@/pages/inmate/MyReentryPlanPage"));
const PreReleaseProgramPage = lazy(() => import("@/pages/inmate/PreReleaseProgramPage"));
const ResourcesPage = lazy(() => import("@/pages/inmate/ResourcesPage").then((m) => ({ default: m.ResourcesPage })));
const ResourceDetail = lazy(() => import("@/pages/inmate/ResourcesPage").then((m) => ({ default: m.ResourceDetail })));
const GamesHub = lazy(() => import("@/pages/inmate/GamesHub"));
const ScenariosPage = lazy(() => import("@/pages/inmate/ScenariosPage"));
const ColoringPage = lazy(() => import("@/pages/inmate/ColoringPage"));
const MemoryGame = lazy(() => import("@/pages/inmate/MemoryGame"));
const WordSearchPage = lazy(() => import("@/pages/inmate/WordSearchPage"));
const MyConsentsPage = lazy(() => import("@/pages/inmate/MyConsentsPage"));
const AccountPage = lazy(() => import("@/pages/inmate/AccountPage"));
const InmateAppointmentsPage = lazy(() => import("@/pages/inmate/InmateAppointmentsPage"));
const MedicalRecordsROIPage = lazy(() => import("@/pages/inmate/MedicalRecordsROIPage"));
const MedicalRecordRequestPage = lazy(() => import("@/pages/inmate/MedicalRecordRequestPage"));
const PropertyInventoryPage = lazy(() => import("@/pages/inmate/PropertyInventoryPage"));
const SickCallPage = lazy(() => import("@/pages/inmate/SickCallPage"));
const GrievancesPage = lazy(() => import("@/pages/inmate/GrievancesPage"));

export function InmateRoutes() {
    return (
        <Route
            path="/inmate"
            element={
                <ProtectedRoute roles={["inmate"]}>
                    <InmateLayout />
                </ProtectedRoute>
            }
        >
            <Route index element={<InmateDashboard />} />
            <Route path="mood" element={<MoodTrackerPage />} />
            <Route path="journal" element={<JournalPage />} />
            <Route path="chat" element={<ChatPage />} />
            <Route path="crisis" element={<CrisisPage />} />
            <Route path="skills" element={<SkillsHub />} />
            <Route path="skills/:slug" element={<SkillDetail />} />
            <Route path="challenges" element={<ChallengesPage />} />
            <Route path="habits" element={<HabitsPage />} />
            <Route path="gratitude" element={<GratitudePage />} />
            <Route path="goals" element={<GoalsPage />} />
            <Route path="insights" element={<InsightsPage />} />
            <Route path="accountability" element={<AccountabilityPage />} />
            <Route path="restoration" element={<RestorationPlanPage />} />
            <Route path="pre-release" element={<PreReleaseProgramPage />} />
            <Route path="reentry-plan" element={<MyReentryPlanPage />} />
            <Route path="resources" element={<ResourcesPage />} />
            <Route path="resources/:resourceId" element={<ResourceDetail />} />
            <Route path="games" element={<GamesHub />} />
            <Route path="scenarios" element={<ScenariosPage />} />
            <Route path="coloring" element={<ColoringPage />} />
            <Route path="memory-game" element={<MemoryGame />} />
            <Route path="word-search" element={<WordSearchPage />} />
            <Route path="consents" element={<MyConsentsPage />} />
            <Route path="account" element={<AccountPage />} />
            <Route path="appointments" element={<InmateAppointmentsPage />} />
            <Route path="medical-records" element={<MedicalRecordsROIPage />} />
            <Route path="property-inventory" element={<PropertyInventoryPage />} />
            <Route path="record-requests" element={<MedicalRecordRequestPage />} />
            <Route path="sick-call" element={<SickCallPage />} />
            <Route path="grievances" element={<GrievancesPage />} />
        </Route>
    );
}
